const services = [
  {
    id: 'team-training',
    name: 'Team Training',
    price: '$500',
    headline: 'A hands-on session to get your team confident with AI.',
    description:
      'We meet your team where they are and teach them to use AI tools safely and effectively in their actual day-to-day. No jargon, no theory\u2014just practical skills they can put to work the next morning. A simple way to start if you\u2019re not sure where to begin.',
  },
  {
    id: 'discovery',
    name: 'Discovery',
    price: '$750',
    headline: 'An AI readiness assessment with a clear roadmap.',
    description:
      'We evaluate your tools, workflows, and team to find the highest-impact AI opportunities, then hand you a prioritized recommendations report and a concrete path forward. You walk away knowing exactly what to do\u2014whether you do it with us or on your own.',
  },
  {
    id: 'setup',
    name: 'Setup',
    price: '$2,250',
    headline: 'Tool implementation, configuration, and a hands-on training session.',
    description:
      'We implement and configure the right AI tools for your business, then train your team in one working session so they can start using them right away. Built for businesses that know what they need and want it done properly the first time.',
  },
  {
    id: 'full-integration',
    name: 'Full Integration',
    price: '$6,000',
    headline: 'End-to-end implementation, team training, and 30 days of support.',
    description:
      'Complete AI integration across your workflows, three comprehensive training sessions, and 30 days of post-launch support to lock in adoption. Our most thorough engagement\u2014designed so the tools actually stick and your team never feels left behind.',
  },
  {
    id: 'ongoing-support',
    name: 'Ongoing Support',
    price: '$750/month',
    headline: 'Keep improving after launch.',
    description:
      'For businesses that want a steady hand as they grow. We stay on call for new tools, optimizations, and questions as they come up\u2014so your AI setup keeps pace with your business instead of going stale. Available after any Setup or Full Integration engagement.',
  },
];

export default services;
